/**
 * MUSKLE — "Mijn MJ Productgids" account hub renderer.
 *
 * Shows ONLY the Productgids the logged-in customer has saved to their account,
 * read from the muskle-points app proxy. MVP: Cream of Rice only (server allowlist).
 *
 * This is intentionally separate from muskle-member-features.js (saved shop products)
 * so the two features never interfere with each other.
 */
(function () {
  'use strict';

  var PROXY_PATH = '/apps/muskle-points/saved-productgids';

  function isEnglish() {
    var lang = (document.documentElement.lang || '').toLowerCase();
    return lang.indexOf('en') === 0;
  }

  var COPY = isEnglish()
    ? {
        title: 'My MJ Product Guides',
        empty: 'You have not saved any Product Guides yet.',
        overview: 'View all Product Guides',
        open: 'Open Product Guide',
        pdf: 'Download PDF',
        remove: 'Remove',
        error: 'Could not load your saved Product Guides right now.',
      }
    : {
        title: 'Mijn MJ Productgids',
        empty: 'Je hebt nog geen Productgidsen opgeslagen.',
        overview: 'Bekijk alle Productgidsen',
        open: 'Open Productgids',
        pdf: 'Download PDF',
        remove: 'Verwijderen',
        error: 'Je opgeslagen Productgidsen konden nu niet worden geladen.',
      };

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function getHub() {
    return document.querySelector('[data-muskle-saved-productgids-hub]');
  }

  function localizeChrome(hub) {
    var titleEl = hub.querySelector('[data-muskle-saved-productgids-title]');
    if (titleEl) titleEl.textContent = COPY.title;
    var overviewEl = hub.querySelector('[data-muskle-saved-productgids-overview]');
    if (overviewEl) overviewEl.textContent = COPY.overview;
  }

  function fetchSaved() {
    return fetch(PROXY_PATH, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    })
      .then(function (res) {
        return res.json().catch(function () {
          return null;
        });
      })
      .catch(function () {
        return null;
      });
  }

  function removeGuide(handle) {
    return fetch(PROXY_PATH, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({ action: 'remove', handle: handle }),
    })
      .then(function (res) {
        return res.json().catch(function () {
          return null;
        });
      })
      .catch(function () {
        return null;
      });
  }

  function pickUrl(entry) {
    return isEnglish() ? entry.url_en || entry.url_nl : entry.url_nl || entry.url_en;
  }

  function pickPdf(entry) {
    return isEnglish() ? entry.pdf_en || entry.pdf_nl : entry.pdf_nl || entry.pdf_en;
  }

  function renderList(hub, saved) {
    var list = hub.querySelector('[data-muskle-saved-productgids-list]');
    var empty = hub.querySelector('[data-muskle-saved-productgids-empty]');
    if (!list) return;

    if (!Array.isArray(saved) || saved.length === 0) {
      list.innerHTML = '';
      if (empty) {
        empty.textContent = COPY.empty;
        empty.hidden = false;
      }
      return;
    }
    if (empty) empty.hidden = true;

    list.innerHTML = '';
    saved.forEach(function (entry) {
      if (!entry || !entry.handle) return;
      var url = pickUrl(entry);
      var pdf = pickPdf(entry);

      var li = document.createElement('li');
      li.className = 'muskle-member-hub__saved-item';

      var card = document.createElement('article');
      card.className = 'muskle-member-hub__saved-card muskle-spg-card';
      card.setAttribute('data-handle', entry.handle);

      var main = document.createElement('div');
      main.className = 'muskle-member-hub__saved-card-main';

      if (entry.image) {
        var img = document.createElement('img');
        img.className = 'muskle-member-hub__saved-card-image';
        img.src = entry.image;
        img.alt = entry.title || '';
        img.loading = 'lazy';
        img.width = 72;
        img.height = 72;
        main.appendChild(img);
      }

      var body = document.createElement('div');
      body.className = 'muskle-member-hub__saved-card-body';

      var title = document.createElement('span');
      title.className = 'muskle-member-hub__saved-card-title';
      title.textContent = entry.title || entry.handle.replace(/-/g, ' ');
      body.appendChild(title);

      if (entry.category) {
        var cat = document.createElement('span');
        cat.className = 'muskle-spg-card__category';
        cat.textContent = entry.category;
        body.appendChild(cat);
      }

      main.appendChild(body);
      card.appendChild(main);

      var actions = document.createElement('div');
      actions.className = 'muskle-member-hub__saved-actions muskle-spg-card__actions';

      if (url) {
        var open = document.createElement('a');
        open.className = 'muskle-member-hub__saved-view';
        open.href = url;
        open.textContent = COPY.open;
        actions.appendChild(open);
      }

      if (pdf) {
        var pdfLink = document.createElement('a');
        pdfLink.className = 'muskle-spg-card__pdf';
        pdfLink.href = pdf;
        pdfLink.target = '_blank';
        pdfLink.rel = 'noopener';
        pdfLink.textContent = COPY.pdf;
        actions.appendChild(pdfLink);
      }

      var remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'muskle-member-hub__saved-remove';
      remove.setAttribute('data-muskle-spg-remove', '');
      remove.setAttribute('data-handle', entry.handle);
      remove.textContent = COPY.remove;
      actions.appendChild(remove);

      card.appendChild(actions);
      li.appendChild(card);
      list.appendChild(li);
    });
  }

  function refresh(hub) {
    fetchSaved().then(function (body) {
      if (body && body.ok && Array.isArray(body.saved)) {
        renderList(hub, body.saved);
      } else {
        // login_required / disabled / error → show empty state (hub is login-gated anyway).
        renderList(hub, []);
      }
    });
  }

  function init() {
    var hub = getHub();
    if (!hub) return;
    localizeChrome(hub);

    hub.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-muskle-spg-remove]');
      if (!btn) return;
      event.preventDefault();
      if (btn.getAttribute('data-busy') === 'true') return;
      btn.setAttribute('data-busy', 'true');
      var handle = btn.getAttribute('data-handle') || '';
      removeGuide(handle)
        .then(function (body) {
          if (body && body.ok && Array.isArray(body.saved)) {
            renderList(hub, body.saved);
          } else {
            refresh(hub);
          }
        })
        .finally(function () {
          btn.removeAttribute('data-busy');
        });
    });

    refresh(hub);
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) refresh(hub);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
